import React, { Component } from 'react';

class FourZeroFour extends Component {

  constructor(props) {
    super(props);
    this.state = {
    }

  }


  render() {
    return(
      <div id="notfound">
        <div class="notfound">
          <div class="notfound-404">
            <h1>404</h1>
          </div>
          <h2 className = "h2404">Oops! This Page Could Not Be Found</h2>
          <p>Sorry but the page you are looking for does not exist, has been removed, or is temporarily unavailable</p>
          <a href="/">Go To Login Page</a>
        </div>
      </div>
  );
  }

}
export default FourZeroFour;



// WEBPACK FOOTER //
// ./src/Components/FourZeroFour.js